import * as api from "api/endpoints/analytics";

import { createSlice, createSliceSelector } from "../../factory";

const name = "overviewMonitoringPage";

const initialState = {
  businessCreditScoreData: [],
  businessCreditScoreUrl: null,
  businessCreditScoreLoading: false,

  monitoredBusinessData: [],
  monitoredBusinessUrl: null,
  monitoredBusinessLoading: false
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectCreditScore = createSelector((state) => {
  return {
    data: state.businessCreditScoreData,
    url: state.businessCreditScoreUrl,
    loading: state.businessCreditScoreLoading
  };
});

export const selectBusiness = createSelector((state) => {
  return {
    data: state.monitoredBusinessData,
    url: state.monitoredBusinessUrl,
    loading: state.monitoredBusinessLoading
  };
});

/* Actions */
const { update } = slice.actions;

export function loadMonitoringData(start, end, portfolioId, epId) {
  return async function (dispatch) {
    dispatch(loadCreditScoreData(start, end, portfolioId, epId));
    dispatch(loadSellersData(start, end, portfolioId, epId));
  };
}

export function loadCreditScoreData(start, end, portfolioId, epId) {
  const config = { params: { start, end, epPortfoliosId: portfolioId, epId } };

  return async function (dispatch) {
    dispatch(update({ businessCreditScoreLoading: true }));

    const data = await api.getCreditScore(config);
    const reportsData = await api.getCreditScoreReports(config);

    const payload = {
      businessCreditScoreData: data.details,
      businessCreditScoreUrl: reportsData.epFileURL,
      businessCreditScoreLoading: false
    };

    dispatch(update(payload));
  };
}

export function loadSellersData(start, end, portfolioId, epId) {
  const config = { params: { start, end, epPortfoliosId: portfolioId, epId } };

  return async function (dispatch) {
    dispatch(update({ monitoredBusinessLoading: true }));

    const data = await api.getSellers(config);
    const reportsData = await api.getSellersReports(config);

    const payload = {
      monitoredBusinessData: data,
      monitoredBusinessUrl: reportsData.epFileURL,
      monitoredBusinessLoading: false
    };

    dispatch(update(payload));
  };
}
